// 查询产品库存相关api

import { axiosPost } from "@/utils/request";

/**
 * 查询产品库存
 * @param {*} data
 * @returns
 */
export const listProductInventory = (data) => {
  return axiosPost({
    url: "/productInventory/selectProductInventory",
    data: data,
  });
};

/**
 * 查询库存报表
 * @param {*} data
 * @returns
 */
export const selectInventoryReport = (data) => {
  return axiosPost({
    url: "/Statistics/selectInventoryChangeByTime",
    data: data,
  });
};
